import { Utils } from "@/plugins/utils"
import router from "@/router"

export default {
	namespaced: true,
	state: {
		lstCf3: [],
		cf3: null,
		insert: false,
		update: false,
		loading: false,
		itemsPerPage: 20,
		search: "",
		hasNext: false
	},
	getters: {},
	mutations: {
		set(state, cf3) {
			state.cf3 = cf3
			if (cf3) state.update = true
		},
		initForm(state) {
			state.insert = false
			state.update = false
			state.cf3 = null
		},
		setParamsDataTable(state, payload) {
			state.lstCf3 = payload.items
			state.itemsPerPage = payload.limit
			state.hasNext = payload.hasNext
		},
		setLstCf3(state, payload) {
			state.lstCf3 = payload
		}
	},
	actions: {
		initForm(store) {
			store.commit("initForm")
		},
		setLstCf3(store, payload) {
			store.commit("setLstCf3", payload)
		},
		async find(store, { cf3local }) {
			store.state.loading = true
			store.commit("initForm")
			await this._vm.$axios
				.get(`/Address/Locale/Find/${cf3local}`)
				.then(response => {
					let cf3 = Utils.ValidateAxiosResponse(response.data)
					store.commit("set", cf3)
				})
				.catch(error => {
					store.dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message
						},
						{ root: true }
					)
				})
			store.state.loading = false
		},
		save(store) {
			if (store.state.update) {
				store.dispatch("update")
				return
			}
			store.dispatch("insert")
		},
		async insert(store) {
			store.dispatch(
				"parameters/openGlobalLoading",
				{ showLoadingGlobal: true, text: "Salvando", indeterminate: true },
				{ root: true }
			)
			await this._vm.$axios
				.post("/Address/Locale/Insert", store.state.cf3)
				.then(response => {
					Utils.ValidateAxiosResponse(response.data)
					router.push("/oryxpdv/localidades")
					store.state.cf3 = null
					return true
				})
				.catch(error => {
					store.dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message
						},
						{ root: true }
					)
					return false
				})
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
		},
		async update(store) {
			store.dispatch(
				"parameters/openGlobalLoading",
				{ showLoadingGlobal: true, text: "Salvando", indeterminate: true },
				{ root: true }
			)
			await this._vm.$axios
				.put("/Address/Locale/Update", store.state.cf3)
				.then(response => {
					Utils.ValidateAxiosResponse(response.data)
					router.push("/oryxpdv/localidades")
					store.state.cf3 = null
					return true
				})
				.catch(error => {
					store.dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message
						},
						{ root: true }
					)
					return false
				})
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
		},
		async delete(store) {
			store.dispatch(
				"parameters/openGlobalLoading",
				{ showLoadingGlobal: true, text: "Excluindo", indeterminate: true },
				{ root: true }
			)
			await this._vm.$axios
				.delete(`/Address/Locale/Delete/${store.state.cf3.cf3local}`)
				.then(response => {
					Utils.ValidateAxiosResponse(response.data)
					router.push("/oryxpdv/localidades")
					return true
				})
				.catch(error => {
					store.dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message
						},
						{ root: true }
					)
					return false
				})
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
		},
		async findList(store) {
			store.state.loading = true
			store.commit("initForm")
			await this._vm.$axios
				.get(`/Address/Locale/FindList`)
				.then(response => {
					let lstCf3 = Utils.ValidateAxiosResponse(response.data)
					store.state.lstCf3 = lstCf3
					store.state.hasNext = lstCf3.length > store.state.itemsPerPage
				})
				.catch(error => {
					store.state.lstCf3 = []
					store.dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message
						},
						{ root: true }
					)
					return false
				})
			store.state.loading = false
		},
		async search(store, { limit = 20, page = 1 }) {
			store.state.loading = true
			store.commit("initForm")
			let payload = await this._vm.$axios
				.get(`/Address/Locale/Search?search=${store.state.search}&limit=${limit}&page=${page}`)
				.then(response => {
					let payload = Utils.ValidateAxiosResponse(response.data)
					store.commit("setParamsDataTable", payload)
					return true
				})
				.catch(error => {
					store.state.lstCf3 = []
					store.state.search = ""
					store.dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message
						},
						{ root: true }
					)
					return false
				})
			store.state.loading = false
			return payload
		}
	}
}
